import {createRouter, createWebHistory} from 'vue-router'

import CartPage from '../pages/cart-page.vue';
import CartConfirm from '../pages/cart-confirm.vue';
import NotFound from '../pages/not-found.vue';

import NewInvoicePage from '../../new-invoice-page/App.vue';

let routes = [];

/* global window */
/* global document*/

if (
    Object.hasOwnProperty.call(window, 'OrderPageData')
    && Object.hasOwnProperty.call(window['OrderPageData'], 'routes')
) {
    routes = window['OrderPageData']['routes'];
}

routes.forEach((route) => {
    switch (route['name']) {
        case 'cart':
            route['component'] = CartPage;
            break;
        case 'confirm':
            route['component'] = CartConfirm;
            break;
        case 'new_invoice':
            route['component'] = NewInvoicePage;
            break;
        case 'not_found':
            route['component'] = NotFound;
            break;
    }
})

let history =  createWebHistory();
history.push(location.pathname);
const router = new createRouter({
    routes,
    history: history
})

router.beforeEach((to, from, next) => {
    if (!to.name) {
        window.location.href = to.fullPath ? to.fullPath : to.path;
        return;
    }
    next()
});

router.afterEach((to) => {
    document.title = to['meta']['title'];
});
export default router